const MODAL_DEFAULT_WIDTH = '1060px'

export default MODAL_DEFAULT_WIDTH
